import React from "react";

const CustomComponentPreview = ({ classes }) => {
  return <div className={`${classes}`}>Custom Component</div>;
};

export default CustomComponentPreview;
